import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

// material-ui
import useMediaQuery from "@mui/material/useMediaQuery";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

// project import
import Drawer from "./Drawer";
import Header from "./Header";
import navigation from "../../menu-items";
import Loader from "../../components/Loader";
import Breadcrumbs from "../../components/@extended/Breadcrumbs";

import '../../../assets/css/admin.css';

import { handlerDrawerOpen, useGetMenuMaster } from "../../api/menu";
import { auth } from "../../../helper/Utility";

export default function DashboardLayout() {
  const navigate = useNavigate()
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down("xl"));

  const authData = auth("admin");

  useEffect(() => {
    if (!authData?.token) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <div className="add">
        <Header />
      </div>
      <Drawer />
      <Box
        component="main"
        sx={{
          width: "calc(100% - 287px)",
          flexGrow: 1,
          pt: "60px",
          p: { xs: 2, sm: 3 },
        }}
      >
        <Toolbar />
        <Breadcrumbs navigation={navigation} title />
        <Outlet />
      </Box>
    </Box>
  );
}
